module.exports = __webpack_public_path__ + "static/media/sketch7151024566.8c48e8b0.png";